import React from 'react';
import { useSelector } from 'react-redux';

import { AppState } from 'services/types';

// Selectors
import { makeSelectEventCreatedBy } from './selectors';

interface Props {
    eventId: number; // eslint-disable-line
}

export default function EventCreatedBy(props: Props): React.ReactElement {
    const createdBy = useSelector((state: AppState) =>
        makeSelectEventCreatedBy()(state, props)
    );

    return <React.Fragment>{createdBy}</React.Fragment>;
}
